var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _path9, _path10, _path11, _g3, _g4, _g5, _g6, _g7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270.619,
    height: 159.27,
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M159.42 133.08a1.12 1.12 0 01-1.12-1.08v-13.46a1.12 1.12 0 012.24 0V132a1.12 1.12 0 01-1.12 1.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M166.13 126.37h-13.42a1.12 1.12 0 110-2.23h13.42a1.12 1.12 0 110 2.23zM399.46 293.36a1.12 1.12 0 01-1.12-1.12V281.8a1.12 1.12 0 012.24 0v10.44a1.12 1.12 0 01-1.12 1.12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M404.68 288.14h-10.44a1.12 1.12 0 010-2.24h10.44a1.12 1.12 0 110 2.24zM92 304.54a1.12 1.12 0 01-1.12-1.12v-6.71a1.12 1.12 0 012.24 0v6.71a1.12 1.12 0 01-1.12 1.12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M95.31 301.18H88.6a1.12 1.12 0 110-2.23h6.71a1.12 1.12 0 110 2.23zM118.79 144.64a1.12 1.12 0 01-1.11-1.12v-6.71a1.12 1.12 0 112.23 0v6.71a1.12 1.12 0 01-1.12 1.12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M122.15 141.28h-6.71a1.12 1.12 0 010-2.24h6.71a1.12 1.12 0 010 2.24zM290.62 328.39a1.12 1.12 0 01-1.11-1.12v-6.71a1.12 1.12 0 012.23 0v6.71a1.12 1.12 0 01-1.12 1.12z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M294 325h-6.71a1.12 1.12 0 010-2.24H294a1.12 1.12 0 010 2.24zM392.75 181.54a4.1 4.1 0 114.1-4.1 4.11 4.11 0 01-4.1 4.1zm0-6a1.87 1.87 0 101.87 1.87 1.87 1.87 0 00-1.87-1.84zM305.53 129.35a5.59 5.59 0 115.59-5.59 5.59 5.59 0 01-5.59 5.59zm0-8.94a3.36 3.36 0 103.36 3.35 3.35 3.35 0 00-3.36-3.35zM208.62 312.74a5.59 5.59 0 115.59-5.59 5.6 5.6 0 01-5.59 5.59zm0-8.95a3.36 3.36 0 103.36 3.36 3.36 3.36 0 00-3.36-3.36z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.42 133.08a1.12 1.12 0 01-1.12-1.08v-13.46a1.12 1.12 0 012.24 0V132a1.12 1.12 0 01-1.12 1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.13 126.37h-13.42a1.12 1.12 0 110-2.23h13.42a1.12 1.12 0 110 2.23zM399.46 293.36a1.12 1.12 0 01-1.12-1.12V281.8a1.12 1.12 0 012.24 0v10.44a1.12 1.12 0 01-1.12 1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.68 288.14h-10.44a1.12 1.12 0 010-2.24h10.44a1.12 1.12 0 110 2.24zM92 304.54a1.12 1.12 0 01-1.12-1.12v-6.71a1.12 1.12 0 012.24 0v6.71a1.12 1.12 0 01-1.12 1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31 301.18H88.6a1.12 1.12 0 110-2.23h6.71a1.12 1.12 0 110 2.23zM118.79 144.64a1.12 1.12 0 01-1.11-1.12v-6.71a1.12 1.12 0 112.23 0v6.71a1.12 1.12 0 01-1.12 1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15 141.28h-6.71a1.12 1.12 0 010-2.24h6.71a1.12 1.12 0 010 2.24zM290.62 328.39a1.12 1.12 0 01-1.11-1.12v-6.71a1.12 1.12 0 012.23 0v6.71a1.12 1.12 0 01-1.12 1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 325h-6.71a1.12 1.12 0 010-2.24H294a1.12 1.12 0 010 2.24zM392.75 181.54a4.1 4.1 0 114.1-4.1 4.11 4.11 0 01-4.1 4.1zm0-6a1.87 1.87 0 101.87 1.87 1.87 1.87 0 00-1.87-1.84zM305.53 129.35a5.59 5.59 0 115.59-5.59 5.59 5.59 0 01-5.59 5.59zm0-8.94a3.36 3.36 0 103.36 3.35 3.35 3.35 0 00-3.36-3.35zM208.62 312.74a5.59 5.59 0 115.59-5.59 5.6 5.6 0 01-5.59 5.59zm0-8.95a3.36 3.36 0 103.36 3.36 3.36 3.36 0 00-3.36-3.36z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M213.26 115.55l-1.57-4.83-1.57 4.83h-5.09l4.11 2.99-1.57 4.84 4.12-2.99 4.11 2.99-1.57-4.84 4.12-2.99h-5.09zM230.24 115.55l-1.58-4.83-1.57 4.83H222l4.12 2.99-1.57 4.84 4.11-2.99 4.12 2.99-1.57-4.84 4.11-2.99h-5.08zM247.21 115.55l-1.57-4.83-1.57 4.83h-5.09l4.11 2.99-1.57 4.84 4.12-2.99 4.11 2.99-1.57-4.84 4.12-2.99h-5.09zM264.19 115.55l-1.57-4.83-1.58 4.83h-5.08l4.11 2.99-1.57 4.84 4.12-2.99 4.11 2.99-1.57-4.84 4.11-2.99h-5.08zM286.25 115.55h-5.09l-1.57-4.83-1.57 4.83h-5.09l4.12 2.99-1.57 4.84 4.11-2.99 4.12 2.99-1.58-4.84 4.12-2.99z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.26 115.55l-1.57-4.83-1.57 4.83h-5.09l4.11 2.99-1.57 4.84 4.12-2.99 4.11 2.99-1.57-4.84 4.12-2.99h-5.09zM230.24 115.55l-1.58-4.83-1.57 4.83H222l4.12 2.99-1.57 4.84 4.11-2.99 4.12 2.99-1.57-4.84 4.11-2.99h-5.08zM247.21 115.55l-1.57-4.83-1.57 4.83h-5.09l4.11 2.99-1.57 4.84 4.12-2.99 4.11 2.99-1.57-4.84 4.12-2.99h-5.09zM264.19 115.55l-1.57-4.83-1.58 4.83h-5.08l4.11 2.99-1.57 4.84 4.12-2.99 4.11 2.99-1.57-4.84 4.11-2.99h-5.08zM286.25 115.55h-5.09l-1.57-4.83-1.57 4.83h-5.09l4.12 2.99-1.57 4.84 4.11-2.99 4.12 2.99-1.58-4.84 4.12-2.99z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M432 316.39c-4.27-2.93-10.66-3.42-10.66-3.42a44.41 44.41 0 0118.33 1.47s-6-4.4-10.23-4.4-11.08-.49-11.08-.49c2.56-2.93 11.93-6.35 11.93-6.35a89.35 89.35 0 00-9.8.49c-3 .49-3.83 3.91-3.83 3.91s-.86-2-7.25-3.42-8.09 3.42-8.09 3.42h6c2.13 0 5.11 2.93 5.11 2.93s-6.81 0-9.37 1.47c-2.2 1.26-5 6.49-5.77 7.93a167.64 167.64 0 017.44-26.46l.17-.13a52.64 52.64 0 006-4.81l7.2 12-.6-10.21s6 1.81 7.81 3.61 7.21 7.8 7.21 7.8-2.4-9-5.41-12a68.57 68.57 0 00-8.41-6.6s6.61 0 9 1.2 9.61 6 9.61 6-4.8-8.4-8.41-10.21-13.21-1.8-13.21-1.8 4.21-3.6 7.21-3.6h8.41s-2.41-6-11.41-4.2-10.21 4.2-10.21 4.2-1.21-4.2-5.41-4.81-13.81-.6-13.81-.6 13.21 4.21 16.81 7.81c0 0-9.61.6-15.61.6s-14.41 5.41-14.41 5.41 12.61-3.61 25.82-1.8c0 0-9 .6-15 4.2s-12 12-12 12a30.82 30.82 0 0112.62-7.21c7.2-1.8 17.41-4.2 17.41-4.2s-10.21 8.41-11.41 12.61a90.42 90.42 0 01-4.8 11.41s8.61-11 13.45-15.5a162.05 162.05 0 00-9.71 49.36c-1.78-7.29-7-22.37-20.56-29.92 2.57.7 6.28 1.72 9.27 2.58 5.12 1.47 8.95 5.86 8.95 5.86s-4.26-6.84-8.52-9.77-10.65-3.42-10.65-3.42a44.19 44.19 0 0118.32 1.47s-6-4.4-10.23-4.4-11.08-.49-11.08-.49c2.56-2.93 11.94-6.35 11.94-6.35a91.45 91.45 0 00-9.81.48c-3 .49-3.83 3.91-3.83 3.91s-.85-1.95-7.24-3.42-8.1 3.42-8.1 3.42h6c2.14 0 5.12 2.94 5.12 2.94s-6.82 0-9.38 1.46-6 8.31-6 8.31 5.11-3.91 6.82-4.89 6.39-1 6.39-1a50.27 50.27 0 00-6 5.37c-2.13 2.44-3.83 9.78-3.83 9.78s3.83-4.89 5.11-6.36 5.54-2.93 5.54-2.93l-.43 8.31 5.12-9.78a38.57 38.57 0 004.26 3.91c3 2.45 10.65 13.69 10.65 13.69a79.82 79.82 0 01-3.41-9.29c-.7-2.82-5.73-8-7.48-9.67 17.37 8.15 22 28.67 22.8 33.41h-7.2l1.59 14h12.68l1.58-14h-7.45a62.69 62.69 0 016.22-19c-.21.81-.34 1.34-.34 1.34s3.84-4.89 5.12-6.35 5.54-2.94 5.54-2.94l-.43 8.31 5.11-9.77a39.87 39.87 0 004.26 3.91c3 2.44 10.66 13.68 10.66 13.68a79.4 79.4 0 01-3.41-9.28c-.85-3.43-8.1-10.27-8.1-10.27s7.25 2 12.36 3.42 8.95 5.87 8.95 5.87-4.23-6.8-8.52-9.74zm-37.45 26.35a151.45 151.45 0 012.65-22.55c.8-.61 5.13-3.89 6.67-4.77 1.71-1 6.39-1 6.39-1a50.52 50.52 0 00-6 5.37 16.65 16.65 0 00-2.42 4.93 56.42 56.42 0 00-7.26 18.02z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M432 316.39c-4.27-2.93-10.66-3.42-10.66-3.42a44.41 44.41 0 0118.33 1.47s-6-4.4-10.23-4.4-11.08-.49-11.08-.49c2.56-2.93 11.93-6.35 11.93-6.35a89.35 89.35 0 00-9.8.49c-3 .49-3.83 3.91-3.83 3.91s-.86-2-7.25-3.42-8.09 3.42-8.09 3.42h6c2.13 0 5.11 2.93 5.11 2.93s-6.81 0-9.37 1.47c-2.2 1.26-5 6.49-5.77 7.93a167.64 167.64 0 017.44-26.46l.17-.13a52.64 52.64 0 006-4.81l7.2 12-.6-10.21s6 1.81 7.81 3.61 7.21 7.8 7.21 7.8-2.4-9-5.41-12a68.57 68.57 0 00-8.41-6.6s6.61 0 9 1.2 9.61 6 9.61 6-4.8-8.4-8.41-10.21-13.21-1.8-13.21-1.8 4.21-3.6 7.21-3.6h8.41s-2.41-6-11.41-4.2-10.21 4.2-10.21 4.2-1.21-4.2-5.41-4.81-13.81-.6-13.81-.6 13.21 4.21 16.81 7.81c0 0-9.61.6-15.61.6s-14.41 5.41-14.41 5.41 12.61-3.61 25.82-1.8c0 0-9 .6-15 4.2s-12 12-12 12a30.82 30.82 0 0112.62-7.21c7.2-1.8 17.41-4.2 17.41-4.2s-10.21 8.41-11.41 12.61a90.42 90.42 0 01-4.8 11.41s8.61-11 13.45-15.5a162.05 162.05 0 00-9.71 49.36c-1.78-7.29-7-22.37-20.56-29.92 2.57.7 6.28 1.72 9.27 2.58 5.12 1.47 8.95 5.86 8.95 5.86s-4.26-6.84-8.52-9.77-10.65-3.42-10.65-3.42a44.19 44.19 0 0118.32 1.47s-6-4.4-10.23-4.4-11.08-.49-11.08-.49c2.56-2.93 11.94-6.35 11.94-6.35a91.45 91.45 0 00-9.81.48c-3 .49-3.83 3.91-3.83 3.91s-.85-1.95-7.24-3.42-8.1 3.42-8.1 3.42h6c2.14 0 5.12 2.94 5.12 2.94s-6.82 0-9.38 1.46-6 8.31-6 8.31 5.11-3.91 6.82-4.89 6.39-1 6.39-1a50.27 50.27 0 00-6 5.37c-2.13 2.44-3.83 9.78-3.83 9.78s3.83-4.89 5.11-6.36 5.54-2.93 5.54-2.93l-.43 8.31 5.12-9.78a38.57 38.57 0 004.26 3.91c3 2.45 10.65 13.69 10.65 13.69a79.82 79.82 0 01-3.41-9.29c-.7-2.82-5.73-8-7.48-9.67 17.37 8.15 22 28.67 22.8 33.41h-7.2l1.59 14h12.68l1.58-14h-7.45a62.69 62.69 0 016.22-19c-.21.81-.34 1.34-.34 1.34s3.84-4.89 5.12-6.35 5.54-2.94 5.54-2.94l-.43 8.31 5.11-9.77a39.87 39.87 0 004.26 3.91c3 2.44 10.66 13.68 10.66 13.68a79.4 79.4 0 01-3.41-9.28c-.85-3.43-8.1-10.27-8.1-10.27s7.25 2 12.36 3.42 8.95 5.87 8.95 5.87-4.23-6.8-8.52-9.74zm-37.45 26.35a151.45 151.45 0 012.65-22.55c.8-.61 5.13-3.89 6.67-4.77 1.71-1 6.39-1 6.39-1a50.52 50.52 0 00-6 5.37 16.65 16.65 0 00-2.42 4.93 56.42 56.42 0 00-7.26 18.02z",
    opacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M153.6 316.39c-4.27-2.93-10.66-3.42-10.66-3.42a44.41 44.41 0 0118.33 1.47s-6-4.4-10.23-4.4-11.08-.49-11.08-.49c2.56-2.93 11.93-6.35 11.93-6.35a89.35 89.35 0 00-9.8.49c-3 .49-3.83 3.91-3.83 3.91s-.86-2-7.25-3.42-8.1 3.42-8.1 3.42h6c2.13 0 5.11 2.93 5.11 2.93s-6.81 0-9.37 1.47c-2.2 1.26-5 6.49-5.77 7.93a166.57 166.57 0 017.44-26.46l.17-.13a53.89 53.89 0 006-4.81l7.2 12-.6-10.21s6 1.81 7.81 3.61 7.21 7.8 7.21 7.8-2.41-9-5.41-12a68.57 68.57 0 00-8.41-6.6s6.61 0 9 1.2 9.61 6 9.61 6-4.8-8.4-8.41-10.21-13.21-1.8-13.21-1.8 4.2-3.6 7.21-3.6h8.41s-2.41-6-11.42-4.2-10.2 4.2-10.2 4.2-1.21-4.2-5.41-4.81-13.81-.6-13.81-.6 13.21 4.21 16.81 7.81c0 0-9.61.6-15.61.6s-14.42 5.41-14.42 5.41 12.62-3.61 25.83-1.8c0 0-9 .6-15 4.2s-12 12-12 12a30.82 30.82 0 0112.62-7.21c7.2-1.8 17.41-4.2 17.41-4.2s-10.21 8.41-11.41 12.61a90.42 90.42 0 01-4.8 11.41s8.61-11 13.45-15.5a162.05 162.05 0 00-9.73 49.36c-1.78-7.29-7-22.37-20.56-29.92 2.57.7 6.28 1.72 9.27 2.58 5.12 1.47 9 5.86 9 5.86s-4.26-6.84-8.52-9.77-10.65-3.42-10.65-3.42a44.19 44.19 0 0118.25 1.51s-6-4.4-10.23-4.4-11.06-.44-11.06-.44c2.56-2.93 11.93-6.35 11.93-6.35a91.29 91.29 0 00-9.8.48C89.86 300.57 89 304 89 304s-.85-1.95-7.25-3.42-8.08 3.42-8.08 3.42h6c2.13 0 5.12 2.94 5.12 2.94s-6.82 0-9.38 1.46-6 8.31-6 8.31 5.11-3.91 6.82-4.89 6.39-1 6.39-1a50.27 50.27 0 00-6 5.37c-2.13 2.44-3.83 9.78-3.83 9.78s3.83-4.89 5.11-6.36 5.54-2.93 5.54-2.93L83 325l5.12-9.78a37.36 37.36 0 004.26 3.91c3 2.45 10.65 13.69 10.65 13.69a79.82 79.82 0 01-3.41-9.29c-.7-2.82-5.73-8-7.49-9.67 17.38 8.15 22 28.67 22.81 33.41h-7.2l1.59 14h12.68l1.58-14h-7.45a62.69 62.69 0 016.22-19c-.21.81-.34 1.34-.34 1.34s3.84-4.89 5.12-6.35 5.54-2.94 5.54-2.94l-.43 8.31 5.11-9.77a39.87 39.87 0 004.26 3.91c3 2.44 10.66 13.68 10.66 13.68a79.4 79.4 0 01-3.41-9.28c-.85-3.43-8.1-10.27-8.1-10.27s7.25 2 12.36 3.42 9 5.87 9 5.87-4.27-6.86-8.53-9.8zm-37.45 26.35a151.45 151.45 0 012.65-22.55c.8-.61 5.13-3.89 6.67-4.77 1.71-1 6.39-1 6.39-1a50.52 50.52 0 00-6 5.37 16.65 16.65 0 00-2.42 4.93 56.42 56.42 0 00-7.29 18.02z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153.6 316.39c-4.27-2.93-10.66-3.42-10.66-3.42a44.41 44.41 0 0118.33 1.47s-6-4.4-10.23-4.4-11.08-.49-11.08-.49c2.56-2.93 11.93-6.35 11.93-6.35a89.35 89.35 0 00-9.8.49c-3 .49-3.83 3.91-3.83 3.91s-.86-2-7.25-3.42-8.1 3.42-8.1 3.42h6c2.13 0 5.11 2.93 5.11 2.93s-6.81 0-9.37 1.47c-2.2 1.26-5 6.49-5.77 7.93a166.57 166.57 0 017.44-26.46l.17-.13a53.89 53.89 0 006-4.81l7.2 12-.6-10.21s6 1.81 7.81 3.61 7.21 7.8 7.21 7.8-2.41-9-5.41-12a68.57 68.57 0 00-8.41-6.6s6.61 0 9 1.2 9.61 6 9.61 6-4.8-8.4-8.41-10.21-13.21-1.8-13.21-1.8 4.2-3.6 7.21-3.6h8.41s-2.41-6-11.42-4.2-10.2 4.2-10.2 4.2-1.21-4.2-5.41-4.81-13.81-.6-13.81-.6 13.21 4.21 16.81 7.81c0 0-9.61.6-15.61.6s-14.42 5.41-14.42 5.41 12.62-3.61 25.83-1.8c0 0-9 .6-15 4.2s-12 12-12 12a30.82 30.82 0 0112.62-7.21c7.2-1.8 17.41-4.2 17.41-4.2s-10.21 8.41-11.41 12.61a90.42 90.42 0 01-4.8 11.41s8.61-11 13.45-15.5a162.05 162.05 0 00-9.73 49.36c-1.78-7.29-7-22.37-20.56-29.92 2.57.7 6.28 1.72 9.27 2.58 5.12 1.47 9 5.86 9 5.86s-4.26-6.84-8.52-9.77-10.65-3.42-10.65-3.42a44.19 44.19 0 0118.25 1.51s-6-4.4-10.23-4.4-11.06-.44-11.06-.44c2.56-2.93 11.93-6.35 11.93-6.35a91.29 91.29 0 00-9.8.48C89.86 300.57 89 304 89 304s-.85-1.95-7.25-3.42-8.08 3.42-8.08 3.42h6c2.13 0 5.12 2.94 5.12 2.94s-6.82 0-9.38 1.46-6 8.31-6 8.31 5.11-3.91 6.82-4.89 6.39-1 6.39-1a50.27 50.27 0 00-6 5.37c-2.13 2.44-3.83 9.78-3.83 9.78s3.83-4.89 5.11-6.36 5.54-2.93 5.54-2.93L83 325l5.12-9.78a37.36 37.36 0 004.26 3.91c3 2.45 10.65 13.69 10.65 13.69a79.82 79.82 0 01-3.41-9.29c-.7-2.82-5.73-8-7.49-9.67 17.38 8.15 22 28.67 22.81 33.41h-7.2l1.59 14h12.68l1.58-14h-7.45a62.69 62.69 0 016.22-19c-.21.81-.34 1.34-.34 1.34s3.84-4.89 5.12-6.35 5.54-2.94 5.54-2.94l-.43 8.31 5.11-9.77a39.87 39.87 0 004.26 3.91c3 2.44 10.66 13.68 10.66 13.68a79.4 79.4 0 01-3.41-9.28c-.85-3.43-8.1-10.27-8.1-10.27s7.25 2 12.36 3.42 9 5.87 9 5.87-4.27-6.86-8.53-9.8zm-37.45 26.35a151.45 151.45 0 012.65-22.55c.8-.61 5.13-3.89 6.67-4.77 1.71-1 6.39-1 6.39-1a50.52 50.52 0 00-6 5.37 16.65 16.65 0 00-2.42 4.93 56.42 56.42 0 00-7.29 18.02z",
    opacity: 0.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.33,
    cy: 377.97,
    fill: "currentColor",
    rx: 28.33,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.33,
    cy: 377.97,
    fill: "#fff",
    opacity: 0.5,
    rx: 28.33,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M113.06 197.2a9.74 9.74 0 00-3.24 3.25c-1.08 2-7.39 20.17-9.37 24.31s-2.88 5.58-.36 7 5.77-.72 7.93-4.68 6.12-14.95 6.84-17.47 3.24-12.05-1.8-12.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M152.05 360.65l1.49 10.67-1 .49-2.97-5.7 2.48-5.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M121.29 296.17s3.23 15.37 6.45 25.29 13.64 33 14.39 37-.25 4-.25 7.19-4.46 6.7-4.71 8.43 3.22 2 6.45 1 5.45-3.72 5.45-6 3-6.2 3-8.43-3.72-2.48-4-6.7-1.74-19.34-4.22-28.27-5-13.64-6.94-16.12-4.46-8.19-4-10.17-11.62-3.22-11.62-3.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M149.07 369.08c0-2.23 3-6.2 3-8.43 0-.94-.66-1.53-1.45-2.21-1.1 2.95-3.34 8.06-6.74 10.89-2.11 1.77-3.5 1.74-4.38 1.23-1.1 1.41-2.19 2.65-2.31 3.48-.25 1.74 3.22 2 6.45 1s5.43-3.72 5.43-5.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M127 299.64s-1 8.18-1 13.39-3 39.56-4 46.13c-.93 6.38-2.73 9.18-3.72 12.65s-2 7.2-3.72 8.19 0 2 3 1.73 6-1.73 6.2-4.46 2.61-5.13 4.22-6.2c3-2-.74-7.94 3.47-20.84 1.86-5.66 6.45-13.14 7.44-21.82s-.74-16.62-.74-18.6 1.74-9.43 1.74-9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M128.75 371.49c3.22-1.23.88-4 .61-7-2.59 2.51-6.05 9-8.07 11a4.23 4.23 0 01-4.41.93c-.62 1.66-1.34 3-2.28 3.54-1.74 1 0 2 3 1.73s6-1.73 6.2-4.46 3.14-5.05 4.95-5.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M129.23 369.08L130 380h-2l-1.74-7.44s1.74-3.72 2.97-3.48zM124.76 195.4l-7.56 2.88s-4.14 9.91-5.58 17.11.54 14.59 2 19.09 3.24 30.44 4 40.34 2.1 24.18 2.1 24.18 3.24 2.53 9.73 3.79 15.67-.72 15.67-.72 5.4-15.67 6.48-24.86-7.93-24.13-10.81-30.61-4-16.93-3.42-20 7.38-26.29 5-27.38-10.76-4.22-17.61-3.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M124.76 189.1s-.72 5-1.26 7.2-4.68 9.73-3.06 13 7 3.24 9.37-2.34a31.19 31.19 0 002-12.07l.9-5.4s-5.78 1.95-7.95-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M146.74 181.18a3.74 3.74 0 00-4.3-1.68c3.26-2.69 5.32-7.05 2.13-13.27-4-7.75-13.32-5.94-13.32-5.94a9.84 9.84 0 00-8.83 4.68c-3.24 5.22-1.44 12.42 1.26 14.41 2.5 1.82 10.34 3.79 15.08 2.25-2.77 2.87-4.56 7-2 10.6a6 6 0 009.65.65c3.21-3.78 2.31-8.28.33-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M124.32 179.78s-2.17-3.58-2.72-1.11.49 4.33 1.21 4.79a2 2 0 001.42.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M124.21 173.41s-3.25 13.33 1.26 18 9.54-2.88 13.68-8.64l1.26-3.78a48.71 48.71 0 00-3.42-5.41 20.89 20.89 0 01-3.06-5.58s-4.68 6-9.72 5.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M138.06 182.85s3.75-1.87 2.89.51-2.72 3.41-3.57 3.41a2.08 2.08 0 01-1.37-.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M131.76 178.25a4.16 4.16 0 014.94-.17M129.2 176.38s-1.87-2-3.91-1.19M128.52 184.89l1.19.52M126.65 186.77a5.8 5.8 0 004.43.68M129.32 180.23a3 3 0 11-1.73-3.65 2.86 2.86 0 011.73 3.65zM136.3 182.11a3 3 0 11-1.72-3.65 2.86 2.86 0 011.72 3.65zM129.37 179.44l1.42.41M136.36 181.49l2.89.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M123.5 196.3a85.93 85.93 0 00-6.5 18.37c-1.8 9-1.62 25.76-1.26 32.24s0 25 0 25l-8.28-3.6s.36-11.71 1.8-19.27a107.76 107.76 0 001.44-21.25c-.18-4.14-2-10.09-.9-15.67s2.7-14.41 3.24-15 10.46-.82 10.46-.82zM131.79 195.94s-3.24 12.79-5.22 24.5 2.88 51 2.88 51a82.31 82.31 0 0010.44-1.26c7.93-1.26 11.71-3.6 11.71-3.6s-4.68-11.89-7.75-18-5.4-11-5.4-11a37.26 37.26 0 01.9-14c2-7.39 7.39-22.51 5.22-24.32s-12.78-3.32-12.78-3.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M139.35 205.13s-2 9-2.7 13.14-2.16 10.27-2.16 10.27-12.61.54-15.67.36-6.3-.18-6.3-.18l1.08 5.76s10.08 3.6 16.39 4.68 9.72 2.71 10.8.73 4.69-22.34 6-30.08 2.16-9.54-3.25-11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M126.93 223.86s6.84-.9 7.38-1.08 7.56 2.88 7.56 2.88-.36.9-.9 1.08-4.86-2-4.86-2l-.72.18 5.4 3.6s.72.9 0 1.26-6.48-3.42-6.48-3.42l5 4.86a1.77 1.77 0 01-2 0c-.9-.72-2.88-2.7-2.88-2.7s2.16 2.52 1.08 2.7-3.06-2.88-3.06-2.88l-3.24-.54-3.42-.36zM116.49 224s-4.54-5.2-4.82-5.69-7.58-2.84-7.58-2.84a2.1 2.1 0 000 1.41c.29.49 5 1.73 5 1.73l.42.61-6.44-.87s-1.13.2-.83.94 7.13 1.72 7.13 1.72l-7 .32a1.77 1.77 0 001.49 1.31c1.15.05 3.94-.12 3.94-.12s-3.29.46-2.59 1.31 4.2-.14 4.2-.14l2.79 1.74 2.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M103.69 223.14s17.65.54 20 .54a19.28 19.28 0 013.25.18l-1.26 8.82a109.65 109.65 0 01-13.33.54c-9.55 0-13.87.54-13.51-3.06s4.85-7.02 4.85-7.02z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.02,
    cy: 385.42,
    fill: "currentColor",
    rx: 28.33,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.02,
    cy: 385.42,
    fill: "#fff",
    opacity: 0.5,
    rx: 28.33,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M177.45 157s-5.88.37-9.66 7.5-2 20-.64 24 7.57 22.95 11.14 36.2 10 25.05 21.51 24.63 27-5.77 22-25.17-15.86-27.38-18-32.33-2.6-10.07-3.55-20.84-8.32-16.72-15.7-18.87-7.1 4.88-7.1 4.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M199.11 188.11c1.88 1.74 2.62 1.79 2.62 1.79M182.48 158.35s.16 7.73 8.36 19.56a80.64 80.64 0 006.77 8.69M184.37 163.55s7.42 17.35 15.94 22.24M206.46 207.56s12.14 14 12.3 24-6.15 14.2-6.78 14.2M212.56 209.64c3.37 6.52 7.1 15.5 6.2 21.9M207.72 201.25s1.2 1.82 2.82 4.66M171.28 172.39s-4.63 9.43-4.13 16.07M169.07 177.91s-.15 5.83 1.58 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M210.86 267.17s-2.24 5-2.24 6.43.28 7.55 1.12 6.43 0-5.31 1.12-5.59 2 .56.84 3.91-2 6.71.28 5 2.23-3.92 3.07-8.95a22.37 22.37 0 00-.28-8.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M203.59 193.37l4.47 41.09 8.11 31.31-7 3.08s-9.22-25.72-11.46-30.47-3.08-8.67-3.08-10.63 8.96-34.38 8.96-34.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M163.06 308s1.11 5.59 1.39 8.38-.56 12.86.84 22.37S174 376.2 174 376.2s-7.27 6.42-7.27 9.5 2.24 2.52 5.87.28 7.27-7.27 7.55-10.62-2.8-22.93-1.68-31.59-.56-23.76-.56-29.91v-6.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M171.16 382.62c-1-.48-.43-2.4.19-3.91-2.08 2.14-4.66 5.16-4.66 7 0 3.07 2.24 2.52 5.87.28a19.26 19.26 0 006.85-8.08c-3.13 3.41-6.97 5.35-8.25 4.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M176.75 309.94s-.28 10.07.84 14.26 8.11 25.72 9.23 32.15a155.19 155.19 0 012.23 20.4c0 4.48 4.2 14.54 7 15.1s4.48.56 3.64-3.91-6.15-11.47-6.15-11.47S196.32 348 195.2 339s-4.2-17.88-4.2-18.71 1.4-11.19 1.4-11.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M197.61 382.8c-.34 1.41-1 2.62-2.13 2.62-2.79 0-5.59-4.75-5.59-4.75l-.14.24c1.31 4.75 4.19 10.52 6.29 10.94 2.8.56 4.48.56 3.64-3.91a19.08 19.08 0 00-2.07-5.14zM175.36 188.34s-19.85 4.19-20.13 5.31 6.43 36.06 6.43 37.46-7.83 19.57-8.39 30.75 3.64 48.36 3.64 48.36 8.38 3.64 16.49 3.64 21.8-2 21.8-2 6.71-21.53 7.27-39.7-7.55-40.81-7.55-40.81 8.67-36.62 8.67-38-18.45-6.13-28.23-5.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M194.92 231.39s8.67-36.62 8.67-38-18.45-6.15-28.23-5c0 0-19.85 4.19-20.13 5.31s6.43 36.06 6.43 37.46c0 1-4 10.51-6.46 19.94a61.78 61.78 0 0011.49 4.66c8.67 2.52 12-1.12 12-1.12s-.84 2 4.19 2.52c4.46.49 12 .32 17.92-3.22a160.13 160.13 0 00-5.88-22.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M179.17 245.92c-.4 2.74-.7 4.56-.7 4.56M180.71 209a130 130 0 01.54 20c-.27 3.36-.75 7.35-1.24 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M177.71 186.18s-5.39 1.8-7.79 3.9-6.29 5.69-6.29 5.69l9.89.6 7.19 12.63 5.09-12.28h6a10.66 10.66 0 014.8 1.2s-6.89-9.29-10.79-11.09a13 13 0 00-8.1-.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M174.42 182.59s.9 12.58 3.29 15.88 5.69-5.39 5.69-9.29.3-9.29.3-9.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M155.23 193.65s-12 40-12 42.77 3.35 5.87 6.71 3.91S160 219.65 160 219.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M139.57 219.09l13.42 26 18.45 1.95-10.9-31.58-20.97 3.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M155.79 235.58l5-9.22 5.87-2 .84 1.12-3.36 2s4.2.27 5.32.27.83 1.68.83 1.68l-.55 1.12s.55 3.63.55 4.75-12.3 4.75-12.3 4.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M156.29 232.82l3.79 10.24s-7.12 3.33-12.24 3.33-7.78-6.67-5.78-10 14.23-3.57 14.23-3.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M179.48 160.1l-9.33 11.26s-.32 8.61 3.94 15.23c5.85 9.12 13.47-9 13.47-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M175.68 174.1c.1.81-.15 1.51-.55 1.56s-.81-.57-.91-1.37.14-1.51.55-1.56.81.57.91 1.37zM181 174.53c0 .81-.34 1.47-.75 1.47s-.72-.67-.72-1.48.34-1.47.74-1.47.73.67.73 1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M175.35 181.66a6.94 6.94 0 004.55-.12M178.62 171a2.83 2.83 0 013.68.18M175.86 171.41a2 2 0 00-3.12-.19M176.78 173.26a4 4 0 01-.18 2.58c-.55 1.67-1.29 2.59-.74 3a3.77 3.77 0 001.66.37"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 356.22,
    cy: 376.47,
    fill: "currentColor",
    rx: 38.76,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 356.22,
    cy: 376.47,
    fill: "#fff",
    opacity: 0.5,
    rx: 38.76,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M351.58 175.67s-1.92-2.47-2.84-1.41 2 7.62 3.25 7.06-.41-5.65-.41-5.65zM366.93 176s1.82-2.4 2.78-1.3-1.65 7.55-2.95 6.94.17-5.64.17-5.64zM353.82 191.71s-3.27 1.42-3.64 3.92 1 56 1 56l22.43 1.21-1-57.9a22.2 22.2 0 00-9-3.74 25.92 25.92 0 00-9.79.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M342.49 249.52l34.35 1.23s3.11 25.49 4.59 42.16 3.7 32.08 3.47 43.67.05 28.94.11 29.55 3.64 3.14 5.91 5.09 7.07 3.8 5.48 4.91-3.65 1.41-7.28.76-7.84-3.13-8.94-3.7l-1.11-.57-.06 1.66-4.14-1.66s-.7-.79-1.26-4.7-1.43-16.05-1.88-21.2-5.22-42.13-7-50.72-5.45-23.52-5.45-23.52-14 48.44-15.74 54.52-9.14 38.89-9.26 39.93-2 3.41-1.95 4-1.86 2.78-3.37 4.71-7.86 3.69-9.54 3.77-2.4-3.4.94-6a70.89 70.89 0 006.41-5.89s1.58-24.68 1.51-32.53 4.57-33.71 5.43-35.82 5.64-31.08 5.64-31.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M353.61 197.81s3.64 22.22 4.06 24.57-5.22 48.83-5.22 48.83a17.45 17.45 0 01-8.61-.92c-5-1.71-9.52-3.58-9.52-3.58l9.54-29.44-8.62-39.42a32.3 32.3 0 017.18-3 77.47 77.47 0 0111.28-2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M357.25 202.24l2.45 3.5-3.23 42.13 5.07 5.78 2.48-5.59-2.4-41.7 2.52-4.55-3.58-5.36-3.31 5.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M366.68 191.84s-2.41 17.85-2.35 19.25-.55 13.15-.5 14.25 5 45.84 5 45.84a28.44 28.44 0 009.53.14c5.52-.8 11.4-4.41 11.4-4.41l-11.1-29.4 4.25-41.27s-13.02-3.78-16.23-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M360.36 199.83l-4.58 4.4s-3-10.17-3-11.74a5 5 0 012.35-4.54c1.71-.94 8.56-.17 10.19.61s2.89 4.53 2.89 4.53L364.55 205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M354.63 184.51s.55 5.63 1.94 8.45 3.33 7.19 3.79 6.87 4.18-6.26 4.28-7.52.37-6.26.37-6.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M354.93 165.75s-3.11 1.85-3.55 3.59-.14 10.67 1.73 14.55 5.35 7.07 7.06 7.09 5.66-2.65 6.21-6.59a59.07 59.07 0 00.87-10.75c-.2-2.64 1.95-1.46-1.32-4.92s-9.09-4.66-11-2.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M357.31 178.06c0 .62-.26 1.13-.57 1.13s-.56-.51-.56-1.13.25-1.12.56-1.12.57.5.57 1.12zM362.64 178.06c0 .62-.25 1.13-.56 1.13s-.56-.51-.56-1.13.25-1.12.56-1.12.56.5.56 1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M354.78 176.24a1.74 1.74 0 012.53-.42M360.82 176s1.12-1.83 3.09.28M360.4 177.92l.28 4.92-2.25-.28M357.73 184.39a6.85 6.85 0 005-.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M352.71 165.58s-3.06-1.09-3.57 2 2.12 8.76 2.12 8.76.42-1.41 1.14-3.13 2.27-2.67 1.68-5.17-1.37-2.46-1.37-2.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M353.26 167.45s1.54 2.51 5.85 3.12 6.51 0 7 .77.54 5.16.54 5.16 1.44.47 1.53-1.25a6.11 6.11 0 011.75-3.6c.46-.47 2.78-1.89.23-5.8s-5.77-5.15-11.33-5.14-8.91 2.84-5.57 6.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M382.88 196.24s8 27.61 8.51 30.5-2.74 4.55-6.14 3.32-5.63-19-5.63-19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M388 220.76s-12.87-2.25-16.22-2.24-19.43 1.48-19.43 1.48l-.6 5.58s24.54 5.53 29.38 6.14 9.65.39 10.15-2.71-.62-4.54-.62-4.54M335.24 197.85s.33 16 .7 24.63 2.78 11.8 7.18 11.79.83-24.8.83-24.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M352.35 220s-3.21-1.64-5.09-1.64-7.39 3.53-7.37 4.15 3 1.44 6.75 1a23.77 23.77 0 016.07 0zM374 215.83a25.51 25.51 0 014.79-.63c2.09 0 4.57 4.12 4.57 4.12l-8.14.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M340.59 224.16l31.66-9.16s.6-.62 1.71.82a8.74 8.74 0 011.22 4.13s-18.69 8.71-24.45 11.2-7.68 6.42-10.77 2.71-1.13-6.82-1.13-6.82"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.97,
    cy: 386.17,
    fill: "currentColor",
    rx: 28.33,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.97,
    cy: 386.17,
    fill: "#fff",
    opacity: 0.5,
    rx: 28.33,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M327.05 169.68a15.42 15.42 0 004.06-8.42c.45-4.82-5.11-7.37-8.87-7.22a11.84 11.84 0 00-6.47 2.4S307 156 300.43 161s-5.72 19.86-5.27 25.42a84.14 84.14 0 01-.3 12.79 64.36 64.36 0 0014.44 3.91c7.67 1.05 18.05-.75 19.1-1s-3-1.21-3.61-7.07.9-12.64 1.51-15.8-.45-9.32-.45-9.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M326.25 156.45s-1.53 5.28-2.38 7.33M320 158.67s1.36 4.42-3.41 12.09-14.47 15.84-14.81 21.46M303.94 179.44s-6 10.05-3.4 16.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M318.78 196.75s8.12 4.21 9.32 4.66 2.26 1.51 3.16 4.21 5.87 22.26 6.32 24.37-3.76 4.21-6.47 4.36-6.17-2.25-6.17-4.06-6.16-33.54-6.16-33.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M322.09 228.64a57.7 57.7 0 015.41-6.17c1.8-1.5 5.56-2.71 7.82-1.5s1.81 3.3.9 3.61-3.16.3-4.66 1.2-3.91 2.56-5.56 3a9.08 9.08 0 01-3.91-.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M297.65 376.63l-.14 8.1h.95l1.21-5.54-2.02-2.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M328.64 307.89s-1.49 20.13-5.4 33.18-11.74 33.35-11.93 36.52c0 0 4.85 4.66 6.52 5.59s3 .75 1.87 1.68-4.29 1.49-6.71.56-4.29-3.73-5.59-4.47-3-1.68-3.17-3.36 2.42-4.1 2.42-4.1 6.15-13.79 5.41-22.55 1.11-18.63 3-22.18a46.73 46.73 0 003-7.26L312.8 309s10.62-3.16 15.84-1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M317.83 383.18a8.71 8.71 0 01-.78-.52c-1 .46-3.46 1.4-5.37-.22-2.14-1.82-4.43-5.09-6.61-7.11a3.66 3.66 0 00-.84 2.26c.18 1.68 1.86 2.61 3.17 3.36s3.16 3.54 5.59 4.47 5.59.37 6.71-.56-.19-.74-1.87-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M326 306s3.64 10.9 3.64 13.7-17.61 42.49-19.29 46.4-4.2 11.18-4.2 11.18a9.26 9.26 0 003.64 5.31c3.07 2.24 4.19 4.2 2.79 4.76s-7.82 1.12-9.5-1.12-3.35-7-5-8.39 0-4.47 1.12-5.31a26.09 26.09 0 003.07-3.35s4.19-8.95 4.19-16.78 1.4-15.37 5.6-21.8a49.46 49.46 0 005.59-10.9l-4.48-9.23s7.27-5 12.83-4.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M310 382.76c-1.63.79-2.78 1.38-6.33-2.65a76.34 76.34 0 01-5.28-6.67c-.9 1.28-1.61 3.35-.31 4.43 1.68 1.4 3.35 6.15 5 8.39s8.11 1.68 9.5 1.12.35-2.44-2.58-4.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M311 195s-18.5 2.85-19.11 3.91 5.72 35.79 6.32 38.5-3.61 9.78-6 23.46.47 17 4.53 26.76S312.16 312 312.16 312l17.75-3.16s4.06-31.73 2.1-47.07a81.81 81.81 0 00-7.82-26.17l.45-8.13s5-3.08 5.19-7-2.63-9.55-5.19-14.66S315 195 311 195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M312.31 192.69s-3.91.45-4.51 1.2-2.41 11.11-2.41 11.11 7.07-2.1 7.82-2.1 6.92 7.22 6.92 7.22v-6.32l5.41 4.06a54.83 54.83 0 00-3.91-8.72c-2.4-4.14-6.01-6.3-9.32-6.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M312.61 183.67s-1.2 11.58-.45 12.93 5.86 9.18 5.86 9.18-.6-6-.6-9.78a46 46 0 011.66-9.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M323.14 164.56s-2.86 7.07-5.72 9.63a26.83 26.83 0 01-5.26 3.76s-.3 5 .45 5.72 6.92 7.06 9 6.16 5.27-6.77 5.57-11.43a38 38 0 00-1.35-10.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M325.23 173.31a2 2 0 00-1.19 2.05c0 1.7 1.53 3.06 1.53 3.91s-1.87 1.37-1.87 1.37M322.51 174.16s-.86-2-3.58-1.36M323.19 183.36a3.92 3.92 0 01-3.41-.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M320.8 175.44c0 .71-.19 1.28-.42 1.28s-.43-.57-.43-1.28.19-1.28.43-1.28.42.58.42 1.28zM325.23 176c0 .7-.19 1.28-.43 1.28s-.42-.58-.42-1.28.19-1.28.42-1.28.43.61.43 1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M295.31 198.56a8.84 8.84 0 00-5 1.35c-2.11 1.5-1.65 7.37-.6 13.69s6.77 23.91 8.12 26.92a8.49 8.49 0 007.37 5c2.86 0 21.66-10.08 21.66-10.08l-1.66-4.66S309.15 234.8 308 235s-6.47-26.77-6.47-26.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M312.46 231.8s-6.17-.16-7.07-.16-5.11 4.82-6.17 6 .15 1.5.61 1.66 3.3-1.06 3.3-1.06-2.55 5-1.95 5.87 2.1 1.5 2.71.9a6.19 6.19 0 012.85-1.35 3.63 3.63 0 003-1.36c1.21-1.35 3.16-6.76 3.16-6.76l3-.91v-2.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M311.86 231.64l1.65 10.08s20.61-5.71 23.16-6.92 1.06-7.67-.9-9.32-23.91 6.16-23.91 6.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M312.16 312l17.75-3.16s4.06-31.73 2.1-47.07a84.36 84.36 0 00-1.75-9.35 48.16 48.16 0 01-13.73 3.33c-11.65 1.29-19.44-2.06-22.41-3.67-.7 2.57-1.38 5.48-2 8.78-2.4 13.69.47 17 4.53 26.76S312.16 312 312.16 312z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M315.27 274.85a61 61 0 016.66 16.46M309.82 267.26a37.63 37.63 0 013.44 4.44"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.79,
    cy: 391.38,
    fill: "currentColor",
    rx: 45.66,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.79,
    cy: 391.38,
    fill: "#fff",
    opacity: 0.5,
    rx: 45.66,
    ry: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M249.33 162.85s-1.68-3.07-2.91-2 .77 8.9 2.3 8.44.61-6.44.61-6.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M218.21 269.13a105.25 105.25 0 0029.41 7.61c16.25 1.64 35.18-10.08 35.18-10.08s-18.93-29.21-19.13-29.83-22.83-1.44-22.83-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M232 244.81s-7.55 32.15-7.55 43.61 0 20.68-.56 29.91-3.63 27.11-2.51 36.34 2.51 27.4 2.51 27.4-9.78 7.82-9.78 10.62 5.87 2 10.9-1.12 6.43-5.31 6.43-5.31l1.12 1.12 1.68-1.68.56-6.15 5.59-50.32 7.83-50 13.69 60.1 12 41.66 2.8 1.12.56 2.51 2.79 1.68 2.8.28 2.79 2.51s8.95 2.8 10.63 2.24 1.67-2.79-2.8-6.15-12-5.31-12-5.31-.84-28.24-2.79-44.73-4.48-30.47-4.48-42.21-3.9-45.93-3.9-45.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M251.3 181.91l-20.87 8 1.67 57.4s7.09 3.54 19.57 3.36 21-.7 21-.7l4.95-62.67-20.13-4.66s-3.77-1.29-6.19-.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M251.49 191.97l2.23 5.78-6.33 44.91 3.35 7.46 5.59-8.57-.74-43.43 2.61-5.78-2.99-5.96-3.72 5.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M251.33 179.28l-3.38 4 .62 12.44 7.06-5.68 5.68 8.29s2.3-10.9 1.38-14.28-4.14-5.53-5.83-5.22-5.53.45-5.53.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M250.41 173.45s0 .24.06.65c.19 2.05.78 8.35 1.17 10.4.46 2.46 3.68 5.22 4.91 4.76s4.15-4.15 4.45-5.37 1.54-6.91 1.54-6.91-4 1.84-5.68 1.84-6.45-5.37-6.45-5.37zM266.48 165.43s2.5-2.46 3.36-1.08-3.28 8.31-4.62 7.43 1.26-6.35 1.26-6.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M255 152.11s-3.83 1.64-4.66 3.56-2.19 12-.82 16.7 4.66 8.76 6.57 9 6.85-2.19 8.22-6.57 2.73-9 3-12 2.46-1.37-.55-5.75-9.33-6.58-11.76-4.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M256.2 165c0 .75-.27 1.36-.64 1.37s-.7-.59-.72-1.34.27-1.36.65-1.37.69.56.71 1.34zM261.53 165.33c0 .75-.27 1.37-.64 1.38s-.7-.59-.72-1.34.27-1.37.64-1.38.7.59.72 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M253.46 161.58a2.66 2.66 0 013.3-.93M259.7 161.18s1.74-.84 3.68 1.42M255.13 172.38a6.47 6.47 0 004.19.47M259.09 163.07s.93 6.49.23 6.84-2.2-.47-2.2-.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M250.87 149s-5.22 1.07-5.07 3.83 2 7.68 2 7.68 1.84 1.07 1.53 2.3-.15 3.84.93 2.92.46-4.3.92-4.76a3.94 3.94 0 001.84-3.07c0-1.84-1.08-3.53-.77-4s5.68.15 8.29 1.38 6.14 3.22 5.22 5.22a2.55 2.55 0 00.31 3.07s-1.08 2.92-.31 3.69 1.69-2.61 1.69-2.61a2.52 2.52 0 002-2.15 20.09 20.09 0 00.61-7.53c-.46-2.45-5.53-6.6-11.05-6.75s-8.14.78-8.14.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M251.48 151.65s6.3 5.52 11.67 7.67 12.28-1.84 12.59-4.91-4.91-7.52-6.29-7.68.76-2-4.3-3.53-16.28-.61-16.89 2.46 3.22 5.99 3.22 5.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M248.69 182.84s-.74 35.41-5 47.52-9.69 24.23-14.35 28.52-12.86 17.89-12.86 17.89-2.8-5.41-2.8-7.08 13-13.61 14.17-14.73 1.68-6.89 1.68-15.46-2.05-48.83-2.05-49.58 17.67-8.01 21.21-7.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M227.45 189.92l-.41.62a133 133 0 00-6.77 14.57c-3.46 8.42-12.58 22.37-10.62 25.16s7 4.47 10.06 1.12 10.62-17.61 10.62-17.61-1.02-20.88-2.88-23.86zM262.3 183.21s.37 24.42 1.11 41.19 3 23.11 4.85 26.28 15.47 24.23 15.47 24.23 3.17-6.53 2.79-9.14-10.25-19.19-10.25-20.12 4.29-55.91 3.54-57.4-17.51-5.04-17.51-5.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M244.78 185.08l-5.41 13.42 4.29 4.28L239 208l2.61 19.94M264.9 185.26l5.04 11.93-5.59 3.35 5.59 8.77-5.41 14.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M232.01 256.27l.94 2.44-6.64 5.12-2.09-4.74 7.79-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M218.87 226.36L232 256.27l-9.78 7.55S208 233.9 208 231.39s3.08-7.55 4.47-8.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M232.95 258.71l2.28 1.14-6.27 8.54-2.65-4.56 6.64-5.12zM267.74 256.7l-1.18 2.34 6.1 5.76 2.55-4.51-7.47-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M279.81 188.25s2.88 3.07 3.26 5.91 10.44 36.26 10.82 37.78-3.42 4-7.22 4.56-8.54-14.24-8.54-14.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M283.8 228.25l-16.06 28.45 9 8.49s17.17-28.34 17.42-30.84-2.3-7.82-3.61-8.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M266.56 259.04l-2.38.9 5.38 9.13 3.1-4.27-6.1-5.76z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakers);
export default __webpack_public_path__ + "static/media/speakers.5e631005.svg";
export { ForwardRef as ReactComponent };